const blogData = {
  blogSection: {
    title: "Our Blogs",
    description:
      "Explore expert blogs by Glowtech Solutions on AI-based digital marketing, HR automation, staffing, web/app development, and growth strategies for modern businesses.",

    latestPostsTitle: "Our Latest Blogs",
    posts: [
      {
        title: "7 React Patterns That Made Me a Better Front-End Developer",
        slug: "7-react-patterns",
        subtitle: "And Probably Saved Me From Smashing My Laptop Into a Wall",
        image: "/blogs/blog1.png",
        author: {
          name: "Tari Ibaba",
          link: "/authors/tari-ibaba",
          linkedIn: "https://linkedin.com/in/tari-ibaba",
          avatar: "/authors/tari-ibaba.jpg",
          bio: "Front-end architect with 8+ years of React experience. Passionate about clean code and teaching best practices.",
        },
        source: "Coding Beauty",
        date: "Apr 11",
        views: "924",
        comments: "27",
        readTime: "8 min",
        topics: ["React", "Frontend", "Best Practices"],
        context:
          "After years of working with React, I've discovered several patterns that transformed my development workflow.",
        description: [
          "When I first started with React, I struggled with component organization and state management. Over time, I discovered patterns that not only made my code cleaner but also reduced bugs and improved performance.",
          "The Container/Presentational pattern was my first breakthrough. By separating logic from presentation, my components became more reusable and easier to test. This pattern alone reduced my bug rate by 40%.",
          "Another game-changer was the Compound Components pattern. This allowed me to create more flexible component APIs that were intuitive for other developers to use. My team's productivity increased significantly after implementing this.",
          "The Render Props pattern helped me share behavior between components without the complexity of higher-order components. I'll walk through real examples of how this simplified complex UIs in our applications.",
        ],
        sections: [
          {
            title: "Container/Presentational Pattern",
            content:
              "This pattern separates concerns by keeping stateful logic in container components while making presentational components purely about UI. In practice, this means your presentational components receive all data and callbacks as props, making them extremely reusable and easy to test.",
            image: "/blogs/container-presentational.png",
            imageCaption:
              "Diagram showing the relationship between container and presentational components",
          },
          {
            title: "Implementing Compound Components",
            content:
              "Compound components work together to form a complete UI. Think of how <select> and <option> work together in HTML. In React, we can create similar relationships using React context to share implicit state between components.",
          },
        ],
        related: ["react-performance", "state-management"],
      },
      {
        title: "This new IDE from Google is an absolute game changer",
        slug: "google-ide",
        subtitle: "This new IDE from Google is seriously revolutionary.",
        image: "/blogs/blog2.png",
        author: {
          name: "Google Dev Team",
          link: "/authors/google-dev-team",
          linkedIn: "https://linkedin.com/in/google-dev",
          avatar: "/authors/google-team.jpg",
          bio: "Google's developer tools team creating the next generation of coding environments.",
        },
        source: "Google Dev Blog",
        date: "Mar 12",
        views: "5.2K",
        comments: "303",
        readTime: "6 min",
        topics: ["IDEs", "Developer Tools"],
        context:
          "Our team at Google has been working on a new IDE that fundamentally changes how developers interact with code.",
        description: [
          "Traditional IDEs have remained largely unchanged for decades. We set out to reimagine what a development environment could be with modern AI and cloud capabilities.",
          "The key innovation is real-time collaboration that actually works. Multiple developers can edit the same file simultaneously with zero latency, complete with live cursors and annotations.",
          "Built-in AI assistance goes beyond simple autocomplete. The IDE can suggest entire refactors, detect potential bugs before runtime, and even explain complex code in plain English.",
          "Performance was a major focus. Despite the advanced features, startup time is under 2 seconds even for massive codebases thanks to our novel indexing approach.",
        ],
        sections: [
          {
            title: "Real-time Collaboration",
            content:
              "Unlike existing solutions that simply show other cursors, our system maintains a fully synchronized state across all participants. Conflict resolution happens automatically using operational transform algorithms.",
          },
          {
            title: "AI-Powered Development",
            content:
              "The AI understands your project's specific architecture and can make context-aware suggestions. It learns from your coding style to provide personalized recommendations.",
          },
        ],
        related: ["vscode-alternatives", "ai-coding"],
      },
      {
        title: "Your React Code Sucks!!!",
        slug: "react-code-review",
        subtitle: "Fix It.",
        image: "/blogs/blog3.png",
        author: {
          name: "Code Reviewer",
          link: "/authors/code-reviewer",
          linkedIn: "https://linkedin.com/in/code-reviewer",
          avatar: "/authors/reviewer.jpg",
          bio: "Professional code reviewer who has seen it all. Specializes in React and JavaScript best practices.",
        },
        source: "Code Quality Weekly",
        date: "Feb 28",
        views: "3.1K",
        comments: "142",
        readTime: "10 min",
        topics: ["React", "Code Quality", "Refactoring"],
        context:
          "After reviewing hundreds of React codebases, I see the same mistakes repeated everywhere.",
        description: [
          "The most common offense? Massive components that do everything. I recently reviewed a 2000-line component that handled API calls, state management, complex rendering, and even animation logic.",
          "Another frequent issue is improper useEffect dependencies. About 70% of React codebases I review have at least one useEffect with missing or incorrect dependencies, leading to subtle bugs.",
          "State management is often over-engineered. Many projects reach for Redux or Context immediately when simple useState would suffice for their actual needs.",
          "In this post, I'll walk through concrete examples of bad React code I've encountered and show how to fix them properly.",
        ],
        sections: [
          {
            title: "Component Decomposition",
            content:
              "Break down large components using the Single Responsibility Principle. Each component should do one thing well. I'll show before/after examples of how this improves readability and maintainability.",
          },
          {
            title: "Proper useEffect Usage",
            content:
              "The React hooks ESLint plugin should be mandatory. I'll demonstrate common useEffect pitfalls and how the exhaustive-deps rule can prevent them.",
          },
        ],
        related: ["react-hooks", "clean-code"],
      },
      {
        title: "7 React Patterns That Made Me a Better Front-End Developer",
        slug: "7-react-patterns",
        subtitle: "And Probably Saved Me From Smashing My Laptop Into a Wall",
        image: "/blogs/blog1.png",
        author: {
          name: "Tari Ibaba",
          link: "/authors/tari-ibaba",
          linkedIn: "https://linkedin.com/in/tari-ibaba",
          avatar: "/authors/tari-ibaba.jpg",
          bio: "Front-end architect with 8+ years of React experience. Passionate about clean code and teaching best practices.",
        },
        source: "Coding Beauty",
        date: "Apr 11",
        views: "924",
        comments: "27",
        readTime: "8 min",
        topics: ["React", "Frontend", "Best Practices"],
        context:
          "After years of working with React, I've discovered several patterns that transformed my development workflow.",
        description: [
          "When I first started with React, I struggled with component organization and state management. Over time, I discovered patterns that not only made my code cleaner but also reduced bugs and improved performance.",
          "The Container/Presentational pattern was my first breakthrough. By separating logic from presentation, my components became more reusable and easier to test. This pattern alone reduced my bug rate by 40%.",
          "Another game-changer was the Compound Components pattern. This allowed me to create more flexible component APIs that were intuitive for other developers to use. My team's productivity increased significantly after implementing this.",
          "The Render Props pattern helped me share behavior between components without the complexity of higher-order components. I'll walk through real examples of how this simplified complex UIs in our applications.",
        ],
        sections: [
          {
            title: "Container/Presentational Pattern",
            content:
              "This pattern separates concerns by keeping stateful logic in container components while making presentational components purely about UI. In practice, this means your presentational components receive all data and callbacks as props, making them extremely reusable and easy to test.",
            image: "/blogs/container-presentational.png",
            imageCaption:
              "Diagram showing the relationship between container and presentational components",
          },
          {
            title: "Implementing Compound Components",
            content:
              "Compound components work together to form a complete UI. Think of how <select> and <option> work together in HTML. In React, we can create similar relationships using React context to share implicit state between components.",
          },
        ],
        related: ["react-performance", "state-management"],
      },
      {
        title: "This new IDE from Google is an absolute game changer",
        slug: "google-ide",
        subtitle: "This new IDE from Google is seriously revolutionary.",
        image: "/blogs/blog2.png",
        author: {
          name: "Google Dev Team",
          link: "/authors/google-dev-team",
          linkedIn: "https://linkedin.com/in/google-dev",
          avatar: "/authors/google-team.jpg",
          bio: "Google's developer tools team creating the next generation of coding environments.",
        },
        source: "Google Dev Blog",
        date: "Mar 12",
        views: "5.2K",
        comments: "303",
        readTime: "6 min",
        topics: ["IDEs", "Developer Tools"],
        context:
          "Our team at Google has been working on a new IDE that fundamentally changes how developers interact with code.",
        description: [
          "Traditional IDEs have remained largely unchanged for decades. We set out to reimagine what a development environment could be with modern AI and cloud capabilities.",
          "The key innovation is real-time collaboration that actually works. Multiple developers can edit the same file simultaneously with zero latency, complete with live cursors and annotations.",
          "Built-in AI assistance goes beyond simple autocomplete. The IDE can suggest entire refactors, detect potential bugs before runtime, and even explain complex code in plain English.",
          "Performance was a major focus. Despite the advanced features, startup time is under 2 seconds even for massive codebases thanks to our novel indexing approach.",
        ],
        sections: [
          {
            title: "Real-time Collaboration",
            content:
              "Unlike existing solutions that simply show other cursors, our system maintains a fully synchronized state across all participants. Conflict resolution happens automatically using operational transform algorithms.",
          },
          {
            title: "AI-Powered Development",
            content:
              "The AI understands your project's specific architecture and can make context-aware suggestions. It learns from your coding style to provide personalized recommendations.",
          },
        ],
        related: ["vscode-alternatives", "ai-coding"],
      },
      {
        title: "Your React Code Sucks!!!",
        slug: "react-code-review",
        subtitle: "Fix It.",
        image: "/blogs/blog3.png",
        author: {
          name: "Code Reviewer",
          link: "/authors/code-reviewer",
          linkedIn: "https://linkedin.com/in/code-reviewer",
          avatar: "/authors/reviewer.jpg",
          bio: "Professional code reviewer who has seen it all. Specializes in React and JavaScript best practices.",
        },
        source: "Code Quality Weekly",
        date: "Feb 28",
        views: "3.1K",
        comments: "142",
        readTime: "10 min",
        topics: ["React", "Code Quality", "Refactoring"],
        context:
          "After reviewing hundreds of React codebases, I see the same mistakes repeated everywhere.",
        description: [
          "The most common offense? Massive components that do everything. I recently reviewed a 2000-line component that handled API calls, state management, complex rendering, and even animation logic.",
          "Another frequent issue is improper useEffect dependencies. About 70% of React codebases I review have at least one useEffect with missing or incorrect dependencies, leading to subtle bugs.",
          "State management is often over-engineered. Many projects reach for Redux or Context immediately when simple useState would suffice for their actual needs.",
          "In this post, I'll walk through concrete examples of bad React code I've encountered and show how to fix them properly.",
        ],
        sections: [
          {
            title: "Component Decomposition",
            content:
              "Break down large components using the Single Responsibility Principle. Each component should do one thing well. I'll show before/after examples of how this improves readability and maintainability.",
          },
          {
            title: "Proper useEffect Usage",
            content:
              "The React hooks ESLint plugin should be mandatory. I'll demonstrate common useEffect pitfalls and how the exhaustive-deps rule can prevent them.",
          },
        ],
        related: ["react-hooks", "clean-code"],
      },
    ],
  },
  posts: [
    {
      title: "7 React Patterns That Made Me a Better Front-End Developer",
      slug: "7-react-patterns-that-made-me-a-better-front-end-developer",
      subtitle: "And Probably Saved Me From Smashing My Laptop Into a Wall",
      image: "/blogs/blog1.png",
      author: {
        name: "Tari Ibaba",
        link: "/authors/tari-ibaba",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Coding Beauty",
      date: "Apr 11",
      views: "924",
      comments: "27",
      topics: ["React", "Frontend", "Best Practices"],
    },
    {
      title: "This new IDE from Google is an absolute game changer",
      slug: "this-new-ide-from-google-is-an-absolute-game-changer",
      subtitle: "This new IDE from Google is seriously revolutionary.",
      image: "/blogs/blog2.png",
      author: {
        name: "Google Dev Team",
        link: "/authors/google-dev-team",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Google Dev Blog",
      date: "Mar 12",
      views: "5.2K",
      comments: "303",
      topics: ["IDEs", "Developer Tools"],
    },
    {
      title: "Your React Code Sucks!!!",
      slug: "your-react-code-sucks",
      subtitle: "Fix It.",
      image: "/blogs/blog3.png",
      author: {
        name: "Code Reviewer",
        link: "/authors/code-reviewer",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Code Quality Weekly",
      date: "Feb 28",
      views: "3.1K",
      comments: "142",
      topics: ["React", "Code Quality", "Refactoring"],
    },
    {
      title: "10 JavaScript Tricks You Should Know",
      slug: "10-javascript-tricks-you-should-know",
      subtitle: "Boost your coding skills with these techniques",
      image: "/blogs/blog4.png",
      author: {
        name: "Alex Johnson",
        link: "/authors/alex-johnson",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "JS Mastery",
      date: "Jan 15",
      views: "2.8K",
      comments: "89",
      topics: ["JavaScript", "Tips & Tricks"],
    },
    {
      title: "The Future of Web Development",
      slug: "the-future-of-web-development",
      subtitle: "What to expect in the next 5 years",
      image: "/blogs/blog5.png",
      author: {
        name: "Sarah Williams",
        link: "/authors/sarah-williams",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Tech Trends",
      date: "Dec 5",
      views: "4.5K",
      comments: "210",
      topics: ["Web Development", "Future Tech"],
    },
    {
      title: "CSS Grid vs Flexbox",
      slug: "css-grid-vs-flexbox",
      subtitle: "When to use each for optimal layouts",
      image: "/blogs/blog6.png",
      author: {
        name: "Mike Chen",
        link: "/authors/mike-chen",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Web Design",
      date: "Nov 20",
      views: "3.7K",
      comments: "156",
      topics: ["CSS", "Layout", "Responsive Design"],
    },
    {
      title: "TypeScript Best Practices",
      slug: "typescript-best-practices",
      subtitle: "How to write cleaner, safer code",
      image: "/blogs/blog7.png",
      author: {
        name: "David Lee",
        link: "/authors/david-lee",
        linkedIn: "https://linkedin.com/in/tari-ibaba",
      },
      source: "Coding Standards",
      date: "Oct 8",
      views: "2.9K",
      comments: "134",
      topics: ["TypeScript", "Best Practices"],
    },
  ],
  blogCategoriesSection: {
    title: "Blog Categories",
  },
  whyFollowBlog: {
    title: "Why Follow Our Blog?",
    reasons: [
      "Expert insights from certified professionals",
      "Actionable tips for marketers and businesses",
      "Real-world examples and case studies",
      "Updates on tools, trends & algorithm changes",
      "Beginner to advanced level content",
    ],
  },
  subscribeSection: {
    title: "Subscribe for Weekly Insights",
    description:
      "Stay ahead of the game! Sign up for our newsletter and receive expert tips, trends, and updates delivered straight to your inbox.",
    icon: "📩",
    email: " contact@glowtechsolutions.in",
  },
  contributeSection: {
    title: "Want to Contribute?",
    description:
      "Are you a digital marketing enthusiast or writer? Pitch your ideas or submit your guest post to:",
    icon: "📩",
    email: " contact@glowtechsolutions.in",
  },
};

export default blogData;
